'use client';

import React from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  React.useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="bg-gray-900 text-white flex items-center justify-center h-screen text-center">
      <div className="p-8">
        <h2 className="text-2xl font-bold text-red-500 mb-4">Wystąpił błąd</h2>
        <p className="mb-6">Coś poszło nie tak. Spróbuj ponownie.</p>
        <button
          onClick={reset}
          className="bg-red-600 hover:bg-red-500 text-white font-bold py-2 px-4 rounded"
        >
          Spróbuj ponownie
        </button>
      </div>
    </div>
  );
}

